import React, { useMemo } from 'react'
import { Badge, RecordList } from '../BusinessDetailReport/BusinessDetailReport'
import styles from '../BusinessDetailReport/BusinessDetailReport.module.scss'
import { buildDeaRegistrations, buildFirearmLicenses, buildLicenses } from './licensesModel'

const plural = (n, one, many = `${one}s`) => `${n} ${n === 1 ? one : many}`

export default function ProfessionalLicenses({ licenses, person, showSummary = true }) {
    const model = useMemo(() => buildLicenses(licenses), [licenses])
    const firearms = useMemo(() => buildFirearmLicenses(person), [person])
    const { summary, rows } = model
    if (!rows.length && !firearms.rows.length) return <div className={styles.calmLine}>No professional licenses found.</div>
    return (
        <div className={styles.uccList}>
            {showSummary && (
                <div className={styles.inlineBadges}>
                    <Badge tone='neutral'>{plural(summary.count, 'license')}{summary.active ? ` · ${summary.active} active` : ''}</Badge>
                    {summary.disciplinary > 0 && <Badge tone='declined' dot>{summary.disciplinary} with disciplinary action</Badge>}
                    {summary.medical > 0 && <Badge tone='neutral'>{summary.medical} medical</Badge>}
                </div>
            )}
            {rows.length > 0 && <RecordList items={rows} />}
            {firearms.rows.length > 0 && (
                <>
                    <div className={styles.uccGroupTitle}>{plural(firearms.rows.length, 'firearms or explosives license', 'firearms or explosives licenses')}</div>
                    <RecordList items={firearms.rows} />
                </>
            )}
        </div>
    )
}

export function DeaRegistrations({ registrations }) {
    const model = useMemo(() => buildDeaRegistrations(registrations), [registrations])
    if (!model.rows.length) return <div className={styles.calmLine}>No DEA registrations found.</div>
    return (
        <div className={styles.uccList}>
            <RecordList items={model.rows} />
        </div>
    )
}
